import { DollarOutlined, FileTextOutlined, HomeOutlined, TeamOutlined, WalletOutlined } from '@ant-design/icons';
import { NavItemType } from 'types/menu';

// Same shape as front-end/src/menu-items: groups of items, rendered by the drawer's Navigation.
const menuItems: { items: NavItemType[] } = {
  items: [
    {
      id: 'referrals',
      title: 'Referrals',
      type: 'group',
      children: [
        { id: 'overview', title: 'Overview', type: 'item', icon: HomeOutlined, url: '/overview' },
        { id: 'customers', title: 'Customers', type: 'item', icon: TeamOutlined, url: '/customers' }
      ]
    },
    {
      id: 'earnings',
      title: 'Earnings',
      type: 'group',
      children: [
        { id: 'commissions', title: 'Commissions', type: 'item', icon: DollarOutlined, url: '/commissions' },
        { id: 'statements', title: 'Statements', type: 'item', icon: FileTextOutlined, url: '/statements' },
        { id: 'payouts', title: 'Payouts', type: 'item', icon: WalletOutlined, url: '/payouts' }
      ]
    }
  ]
};

export default menuItems;
